import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-add-profile-dialog",
  templateUrl: "./add-profile-dialog.component.html",
})
export class AddProfileDialogComponent {
  profiles = [
    { name: "Profile 1" },
    { name: "Profile 2" },
    { name: "Profile 3" },
    { name: "Profile 4" },
    { name: "Profile 5" },
  ];
  selectedProfiles: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
